export default __webpack_public_path__ + "static/Chiro Charge-a346b999986ca5cb5233d311f4e8b40e.jpg";